import { cloudFilesMigrationDesktop } from 'reactApp/appHelpers/featuresHelpers/features/cloudFilesMigrationDesktop';
import { FilesMigrationStatus } from 'reactApp/modules/filesMigration/filesMigration.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getFilesMigrationState = (state: RootState) => state.filesMigration;

export const getFilesMigrationStatus = (state: RootState) => getFilesMigrationState(state).status;

export const getAllChatsCount = (state: RootState) => getFilesMigrationState(state).allChatsCount;

export const getMigratedChatsCount = (state: RootState) => getFilesMigrationState(state).migratedChatsCount;

export const getMigratedBytes = (state: RootState) => getFilesMigrationState(state).migratedBytes;

export const hasActiveMigration = createSelector(getFilesMigrationStatus, (status) => {
    return status === FilesMigrationStatus.inProgress;
});

export const hasWaitForMigration = createSelector(getFilesMigrationStatus, (status) => {
    return status === FilesMigrationStatus.waitTakeout || status === FilesMigrationStatus.authed;
});

export const hasWaitForCancel = createSelector(getFilesMigrationStatus, (status) => {
    return status === FilesMigrationStatus.cancelInProgress;
});

export const hasNoMigration = createSelector(getFilesMigrationStatus, (status) => {
    return status === null;
});

export const getIsLoading = (state: RootState) => getFilesMigrationState(state).isLoading;

export const getIsStatusClosed = (state: RootState) => getFilesMigrationState(state).isStatusClosed;

export const getIsStatusHide = createSelector(hasNoMigration, getIsStatusClosed, (isNoMigration, isStatusClosed) => {
    return isNoMigration || isStatusClosed || !cloudFilesMigrationDesktop;
});
